import { render } from "./AvailmentReportIndex.vue?vue&type=template&id=51841086"
import script from "./AvailmentReportIndex.vue?vue&type=script&lang=js"
export * from "./AvailmentReportIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__